var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { ArrowPathIcon, ChatBubbleLeftIcon } from "@heroicons/react/24/outline";
import { useEffect, useState } from "@wordpress/element";
import { __ } from "@wordpress/i18n";
import { useTimezone } from "../../../hooks/useTimezone";
import { WPQTLogCreatedBy } from "../../../types/enums";
import { LoadingOval } from "../../Loading/Loading";
import { WPQTIconButton } from "../../common/Button/Button";
import { WPQTTextarea } from "../../common/TextArea/TextArea";
function CommentsAndLogsTabContent({ typeId, fetchData, renderItem, noDataMessage, explanation, onAdd = () => __awaiter(this, void 0, void 0, function* () { return undefined; }), enableAdd = false, }) {
    const [data, setData] = useState(null);
    const [newEntry, setNewEntry] = useState("");
    const [loadingComments, setLoadingComments] = useState(true);
    const [addingEntry, setAddingEntry] = useState(false);
    useEffect(() => {
        loadData();
    }, [typeId]);
    const loadData = () => __awaiter(this, void 0, void 0, function* () {
        setLoadingComments(true);
        const data = yield fetchData();
        if (data) {
            setData(data);
        }
        setLoadingComments(false);
    });
    const addEntry = () => __awaiter(this, void 0, void 0, function* () {
        setAddingEntry(true);
        const entry = yield onAdd(newEntry);
        if (entry) {
            setData((prevData) => (prevData ? [...prevData, entry] : [entry]));
            setNewEntry("");
        }
        setAddingEntry(false);
    });
    if (data === null) {
        return (_jsx("div", { className: "wpqt-flex wpqt-justify-center", children: _jsx(LoadingOval, { width: "30", height: "30" }) }));
    }
    return (_jsxs("div", { children: [explanation && (_jsx("div", { className: "wpqt-mb-3 wpqt-text-center wpqt-font-semibold", children: explanation })), data.length === 0 && (_jsx("div", { className: "wpqt-mb-3 wpqt-text-center", children: noDataMessage })), data.length > 0 && (_jsx("div", { className: "wpqt-mb-[28px] wpqt-mt-[56px] wpqt-grid wpqt-grid-cols-[0.3fr_1fr_0.3fr] wpqt-place-items-center wpqt-gap-8", children: data.map((item) => renderItem(item)) })), _jsx("div", { className: "wpqt-mb-3 wpqt-flex wpqt-justify-center", children: _jsx(CommentsRefresh, { isLoading: loadingComments, refreshComemnts: loadData }) }), enableAdd && (_jsx("div", { className: "wpqt-flex wpqt-justify-center", children: _jsxs("div", { className: "wpqt-w-2/3", children: [_jsx(WPQTTextarea, { rowsCount: 3, value: newEntry, onChange: (text) => setNewEntry(text), className: "wpqt-mb-4 wpqt-w-full" }), _jsx(WPQTIconButton, { text: "Add comment", loading: addingEntry, onClick: addEntry, className: "wpqt-float-right", icon: _jsx(ChatBubbleLeftIcon, { className: "wpqt-icon-blue wpqt-size-5" }) })] }) }))] }));
}
function CommentsRefresh({ isLoading, refreshComemnts }) {
    return (_jsx(_Fragment, { children: isLoading ? (_jsx(LoadingOval, { width: "32", height: "32" })) : (_jsx(ArrowPathIcon, { className: "wpqt-icon-blue wpqt-size-8 wpqt-cursor-pointer hover:wpqt-text-qtBlueHover", onClick: refreshComemnts })) }));
}
function TabContentItem({ log }) {
    const { convertToWPTimezone } = useTimezone();
    return (_jsxs(_Fragment, { children: [_jsxs("div", { children: [_jsx("div", { className: "wpqt-text-center wpqt-mb-1", children: log.author_name }), _jsx("div", { className: "wpqt-text-center", children: log.created_by === WPQTLogCreatedBy.Admin
                            ? __("Admin", "quicktasker")
                            : __("QuickTasker", "quicktasker") })] }), _jsx("div", { children: log.text }), _jsx("div", { children: convertToWPTimezone(log.created_at) })] }));
}
function TabContentCommentItem({ item }) {
    const { convertToWPTimezone } = useTimezone();
    return (_jsxs(_Fragment, { children: [_jsxs("div", { children: [_jsx("div", { className: "wpqt-text-center wpqt-mb-1", children: item.author_name }), _jsx("div", { className: "wpqt-text-center", children: item.is_admin_comment
                            ? __("Admin", "quicktasker")
                            : __("QuickTasker", "quicktasker") })] }), _jsx("div", { children: item.text }), _jsx("div", { children: convertToWPTimezone(item.created_at) })] }));
}
export { CommentsAndLogsTabContent, TabContentCommentItem, TabContentItem };
